import buildUrl from '../utils/buildUrl';
import { baseUrl } from './baseUrl';

export const profileRoute = (): string =>
  buildUrl({
    url: `${baseUrl}/applications/v1/profile`,
  });
